import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderTwo from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/Footer";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import BlogDetails from "../components/BlogDetails";
import ScrollToTop from "react-scroll-to-top";
const BlogDetailsPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb */}
      <Breadcrumb title={"Blog Details"} />

      {/* BlogDetails */}
      <BlogDetails />

      {/* ShippingOne */}
      <ShippingOne />
    </>
  );
};

export default BlogDetailsPage;
